@if(show){
<div class="policy-container">
  @if(this.commonService?.currentRoute?.includes('/privacy-policy')){
  <button type="button" class="btn-close float-end" aria-label="Close" [routerLink]="'/home'"></button>
  }
  <h1>Data Protection and Privacy Policy</h1>

  <h2>1. Introduction</h2>
  <p>
    EcoCash Private Limited (hereafter referred to as ‘EcoCash’, ‘We’, ‘Us’,
    ‘Our’ and ‘Ours’) acknowledges that information technology should be at the
    service of every stakeholder. Information technology development shall take
    place in the context of international co-operation. Information technology
    shall not violate human identity, human rights, privacy, individual or
    public rights.
  </p>
  <p>
    EcoCash is therefore committed to protecting your privacy, keeping your
    information safe and ensuring the security of your personal information. In
    our efforts to provide you with the most effective products and services,
    your personal information will be collected, processed lawfully, stored
    securely and not disclosed unlawfully to any third party.
  </p>
  <p>
    Data Protection and Privacy is implemented compliant to requirements listed
    in statutory, regulatory, contractual documents, and within frameworks such
    as:
  </p>
  <ul>
    <li>Zimbabwe National Payment System</li>
    <li>International Best Practice frameworks</li>
  </ul>

  <h2>2. Purpose of the Data Protection Policy</h2>
  <p>
    We believe that you should always know the data we collect from you and how
    we use it, as well as maintain adequate control over both. We want to
    empower you to make the best decisions about the information that is shared
    with us.
  </p>
  <p>
    This Data Protection and Privacy Policy applies worldwide to EcoCash, is
    based on globally accepted, basic principles on data protection and privacy
    and ensures adequate level of data protection as prescribed by relevant
    legal frameworks, including in countries that do not yet have adequate data
    protection laws.
  </p>
  <p>
    Therefore, the purpose of this Data Protection and Privacy Policy is to give
    you and our stakeholders guidance and information on how we collect, use,
    and protect personal information. The privacy notice will tell you:
  </p>
  <ul>
    <li>Why we collect your personal information and how we may process it</li>
    <li>How and when we share your information with third parties</li>
    <li>How we protect your information</li>
    <li>How long we hold onto your information</li>
    <li>Information on your rights</li>
  </ul>

  <h2>3. To Whom Does the Policy Apply?</h2>
  <ul>
    <li>
      All Customers and/or users who are natural persons or living individuals
    </li>
    <li>All Customers and/or users who are organizations</li>
    <li>
      Anyone identifiable by reference to an ID number or personal attributes
    </li>
    <li>All Ecocash employees and job applicants or prospective employees</li>
    <li>All Ecocash suppliers, partners, and service providers</li>
  </ul>

  <h2>4. Why does EcoCash collect and process Personal Information?</h2>

  <p>
    Processing of personal data means any operation or set of operations in
    relation to such data, whatever the mechanism used, especially the
    obtaining, recording, organization, retention, adaptation or alteration,
    retrieval, consultation, use, disclosure by transmission, dissemination or
    otherwise making available, alignment or combination, blocking, deletion, or
    destruction.
  </p>

  <p>
    EcoCash collects and processes your personal information for a variety of
    business purposes. These include, but are not limited to:
  </p>

  <ul>
    <li>
      Verifying your identity information through publicly available and/or
      restricted government databases in order to comply with applicable
      regulatory requirements.
    </li>
    <li>
      Completing transactions or the processing of products and services that
      you have accessed from EcoCash or from third parties on our ecommerce
      platforms.
    </li>
    <li>Responding to your request for service or assistance.</li>
    <li>
      Performing market analysis and research as well as business and
      operational analysis.
    </li>
    <li>Providing, maintaining, and improving our products and services.</li>
    <li>
      Anticipating and resolving issues and concerns related to our products and
      services.
    </li>
    <li>
      Promoting and marketing our products and services which may benefit you
      and be related to products and services you are currently enjoying.
    </li>
    <li>
      Ensuring adherence to legal and regulatory requirements for prevention and
      detection of fraud and crime.
    </li>
    <li>
      Carrying out credit checks and credit scoring where you are applying for
      specific products and/or services with us, and to assess your application
      and/or eligibility.
    </li>
    <li>
      To comply with any legal, governmental or regulatory requirement or for
      use by our lawyers in connection with any legal proceedings.
    </li>
    <li>
      To administer any of our access channels including but not limited to
      USSD, mobile applications, chatbots, and websites or web portals.
    </li>
  </ul>

  <p>
    EcoCash may keep a log of the activities performed by you on our systems,
    applications, and websites by using various internet techniques such as web
    cookies, web beacons, server log files, etc. for analytical purposes, for
    analysis of the agreeableness of various features in accordance with
    requisite legal requirements. This information may be used to provide you
    with a better experience on our platforms.
  </p>

  <p>
    At any time while you are browsing our websites or accessing our
    applications, if you do not wish to share information, you may opt out of
    receiving the cookies from our site by making appropriate changes to your
    browser privacy or mobile application settings.
  </p>

  <p>
    If we do not provide your consent for usage of personal information or you
    later withdraw your consent for use of the personal information so
    collected, EcoCash will not be able to provide certain products and services
    to you.
  </p>

  <h2>5. What Personal Information Do We Collect?</h2>

  <p>
    EcoCash and its authorized third parties may collect, store and process
    Personal Information while providing our products, services and while
    accessing our website and mobile applications.
  </p>

  <p>
    Personal data and/or sensitive information collected and held by us may
    include:
  </p>

  <ul>
    <li>Names of individuals</li>
    <li>Postal or living addresses</li>
    <li>Email addresses</li>
    <li>Mobile Phone numbers</li>
    <li>Identity card and passport</li>
    <li>Date and place of birth</li>
    <li>Identification of relatives</li>
    <li>Business reference</li>
    <li>Geo-referencing</li>
    <li>Occupation</li>
    <li>Biometric Data</li>
    <li>Racial or Ethnic Origin</li>
    <li>
      Financial information such as your bank account or debit and credit card
      details; financial history or other banking information (including
      information to determine your creditworthiness).
    </li>
    <li>
      Information contained in supporting documents such as proof of identity or
      proof of address.
    </li>
  </ul>

  <p>
    We may also collect your information from other organizations including
    credit-reference bureaus, fraud prevention agencies and business
    directories.
  </p>

  <h2>6. Principles We Adhere to When Managing Your Personal Data</h2>

  <p>
    The EcoCash Data Protection and Privacy Policy comprises the internationally
    accepted data privacy principles without replacing the existing national
    laws. It supplements the national data privacy laws. We rely on the
    following principles in processing your data:
  </p>

  <strong>Fairness and Lawfulness</strong>
  <ul>
    <li>
      When processing personal data, the individual rights of the data subjects
      are protected. Personal data will be collected and processed in a legal
      and fair manner.
    </li>
    <li>
      Collected data shall be adequate, relevant, and not excessive in relation
      to the purposes for which it is obtained and further processed.
    </li>
    <li>
      Individual data should be processed upon voluntary consent of the person
      concerned.
    </li>
  </ul>

  <strong>Restriction to a Specific Purpose</strong>
  <ul>
    <li>
      Personal data will be processed only for the purpose that was defined
      before the data was collected.
    </li>
    <li>
      Personal data shall be obtained for specified, explicit and legitimate
      purposes, and shall not subsequently be processed in a manner that is
      incompatible with those purposes.
    </li>
  </ul>

  <strong>Transparency</strong>
  <ul>
    <li>
      Customers will be informed of how their data is handled. When the data is
      collected, the customer will be made aware of the purpose of data
      processing and any third parties to whom the data might be transmitted.
    </li>
    <li>
      Processing of personal data is done after receiving the consent of the
      customer.
    </li>
  </ul>

  <strong>Confidentiality and Data Security</strong>
  <ul>
    <li>
      Personal data is subject to data secrecy. It will be treated as
      confidential on a personal level and secured with suitable organizational
      and technical measures to prevent unauthorized access, illegal processing,
      or distribution, as well as accidental loss, modification, or destruction.
    </li>
  </ul>

  <strong>Data Retention</strong>
  <ul>
    <li>
      Personal data shall be retained in a form that allows the identification
      of the data subjects for a period no longer than is necessary for the
      purposes for which it was obtained and processed.
    </li>
    <li>
      When we dispose of your personal information, we use reasonable procedures
      to erase it or render it unreadable/anonymized.
    </li>
  </ul>

  <strong>Data Integrity</strong>
  <ul>
    <li>Personal data on file must be correct, complete, and up to date.</li>
    <li>
      Suitable steps are taken to ensure that inaccurate or incomplete data is
      updated.
    </li>
  </ul>

  <strong>Consent to Data Processing</strong>
  <ul>
    <li>
      Individual data will be processed upon consent of the person concerned.
    </li>
    <li>Declarations of consent must be submitted voluntarily.</li>
    <li>
      Transmission of personal data to recipients outside or inside EcoCash is
      subject to the authorization requirements for processing personal data and
      requires customer consent.
    </li>
  </ul>

  <strong>Processing Security</strong>
  <ul>
    <li>
      Personal data will be safeguarded from unauthorized access and unlawful
      processing or disclosure, as well as accidental loss, modification, or
      destruction.
    </li>
  </ul>

  <h2>7. Processing Information of Children</h2>

  <ul>
    <li>
      We will only collect and process the personal information of a child with
      the consent of the parent(s) or legal guardian.
    </li>
    <li>
      We may also need to process the information of a child where it is
      necessary to exercise or defend a right or obligation in law, or where the
      personal information has been made public by the child with the consent of
      the parent(s) or legal guardian.
    </li>
  </ul>

  <h2>8. What Are Your Rights?</h2>

  <ul>
    <strong>Right to be informed:</strong>
    <li>
      You have the right to be informed that we are collecting personal data
      about you.
    </li>
    <strong>Right to access personal information:</strong>
    <ul>
      <li>
        You have the right to request a copy of the personal information that
        EcoCash holds about you (including advertising audience categories and
        inferred information), as permitted by law.
      </li>
    </ul>
    <strong>Right to correct personal information:</strong>
    <ul>
      <li>
        You have the right to correct information held about you to ensure it is
        accurate, relevant, complete, and not excessive.
      </li>
    </ul>
    <strong>Right to object to the use of personal information:</strong>
    <ul>
      <li>
        You have the right to request that we erase your personal data in
        certain circumstances as permitted by law. However, if we are legally
        obligated to retain the data, this right may not be exercisable.
      </li>
      <li>
        You have the right to withdraw consent and object to EcoCash processing
        your personal information in certain circumstances as permitted by law.
        This may not apply where legal obligations justify processing.
      </li>
    </ul>
    <strong>Right to opt out of marketing messages:</strong>
    <ul>
      <li>
        EcoCash will not send targeted marketing unless you have consented.
      </li>
      <li>You can opt out at any time using the tools provided.</li>
      <li>
        If you previously opted in to receive personalized content, you can opt
        out of that as well at any time.
      </li>
    </ul>
  </ul>

  <h2>9. To Whom Will We Disclose Your Information?</h2>

  <p>
    Protecting our interests may sometimes require the disclosure of specific
    client information to third parties, for example, if payment failed due to
    insufficient money in an account. Where required to protect the public
    interest, information regarding a client’s debt may be disclosed to credit
    bureaus or debt collection agencies. Entities and third parties with whom we
    may share your information may include:
  </p>

  <ul>
    <li>Banks and financial institutions</li>
    <li>
      Law enforcement agencies, regulatory organizations, courts or other public
      authorities if we are required to, or authorized to by law
    </li>
    <li>The regulator</li>
    <li>Law firms and auditors</li>
    <li>Insurers</li>
    <li>
      Other third parties as may be required either contractually, by law, or
      under legitimate interest for the processing of products and services from
      third parties on our platforms
    </li>
    <li>
      Where applicable, anti-money laundering agencies, credit reference, fraud
      prevention, or business scoring agencies
    </li>
    <li>Debt collection agencies or other debt recovery organizations</li>
  </ul>

  <p>
    When sharing your information with recipients in other jurisdictions, we
    will ensure that they adhere to similar privacy protection requirements as
    we do – either by law or by legal agreement. We will not sell your
    information to third parties and will only market to you in line with our
    legal obligations and your marketing preference, using the communication
    method you chose.
  </p>

  <p>
    Some of your information may be passed on to any person whom you receive
    mobile money from, send money to, or intend to send mobile money to. Your
    information may be available to any third party involved in the operation of
    the mobile money service, including EcoCash merchants, channel partners,
    financial services switch providers, and vendors of the EcoCash money
    transfer technology platform.
  </p>

  <h2>10. Contact Us</h2>

  <p>
    If you would like to contact us on any topics in this Privacy Policy, or you
    would want to exercise any of the rights mentioned above, you can contact
    our Data Protection Office and our privacy team will get back to you.
  </p>

  <address>
    <strong>EcoCash Private Limited</strong><br />
    1906 Borrowdale Road<br />
    Borrowdale<br />
    Harare, Zimbabwe<br />
    <strong>Email:</strong> <a>{{ "dpo@ecocash.co.zw" }}</a>
  </address>

  <p>
    We may need to request specific information from you to help us confirm your
    identity and ensure your right to access your personal data (or to exercise
    any of your other rights). This is a security measure to ensure that
    personal data is not disclosed to any person who has no right to receive it.
    We may also contact you to ask you for further information in relation to
    your request to expedite our response.
  </p>

  <p>
    We try to respond to all legitimate requests within reasonable time.
    Occasionally it could take us longer if your request is particularly complex
    or you have made several requests. In this case, we will notify you and keep
    you updated.
  </p>

  <h2>11. Changes to Policy</h2>

  <ul>
    <li>
      We reserve the right to modify this Data Privacy Policy as and when
      required.
    </li>
    <li>
      We will post any changes to our Data Protection and Privacy Policy on our
      website:
      <a>https://www.ecocash.co.zw/</a>
    </li>
    <li>
      We encourage you to check frequently to see the current Data Protection
      and Privacy Policy to be informed of how EcoCash is committed to
      protecting your information and providing you with improved products and
      services to enhance your experience.
    </li>
    <li>
      Any amendment or modification to this policy will take effect from the
      date of notification on the EcoCash website.
    </li>
  </ul>

  <h2>12. Statement Effective Date</h2>

  <p><strong>Effective Date:</strong> 26th April 2022</p>

  <h2>13. Record of Version Control</h2>

  <table
    border="1"
    cellpadding="8"
    cellspacing="0"
    style="border-collapse: collapse; width: 100%; max-width: 100%"
  >
    <thead style="background-color: #f2f2f2">
      <tr>
        <th>Date</th>
        <th>Version</th>
        <th>Author(s)</th>
        <th>Change</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>2022/04/04</td>
        <td>1.0</td>
        <td>Nathan Nyabvure</td>
        <td>Document Initiation</td>
      </tr>
      <tr>
        <td>2023/03/07</td>
        <td>1.1</td>
        <td>Tania Magasa</td>
        <td>Annual Review – Amendment to section 1 Introduction</td>
      </tr>
      <tr>
        <td>2024/03/25</td>
        <td>1.2</td>
        <td>Ropafadzo Maseko</td>
        <td>
          Annual Review – Addition and update of clauses 4.2.1, 4.2.2, 4.2.9,
          4.2.10, 4.2.11, Clause 5, 5.2.13, 5.3, 9.1.2, 9.1.7
        </td>
      </tr>
      <tr>
        <td>2025/01/31</td>
        <td>1.3</td>
        <td>Ropafadzo Maseko</td>
        <td>
          Annual Review – Changing branding and content to EcoCash Private
          Limited
        </td>
      </tr>
    </tbody>
  </table>

  @if(!this.commonService?.currentRoute?.includes('/privacy-policy')){
  <div class="policy-footer">
    <button
      data-bs-dismiss="modal"
      class="btn done button_class"
    >
      Okay
    </button>
  </div>
  }
</div>
}
